import { types, flow, applySnapshot, destroy } from 'mobx-state-tree';
import axios from 'axios';

export const ApiStore = types.model('ApiStore', {
    isLoading: types.optional(types.boolean, false)
}).actions(self => ({
    getApi: flow(function* getApi(url, applyTo) {
        return yield processApiCall(() => axios.get(url), self, applyTo);
    }),
    patchApi: flow(function* patchApi(url, patch, applyTo) {
        return yield processApiCall(() => axios.patch(url, patch), self, applyTo);
    }),
    postApi: flow(function* postApi(url, body, applyTo) {
        return yield processApiCall(() => axios.post(url, body), self, applyTo);
    }),
    putApi: flow(function* putApi(url, body, applyTo) {
        return yield processApiCall(() => axios.put(url, body), self, applyTo);
    }),
    deleteApi: flow(function* deleteApi(url, applyTo) {
        self.isLoading = true;
        try {
            yield axios.delete(url);

            if (applyTo) {
                destroy(applyTo);
            }
        } catch (error) {
            handleError(error);
        }
        finally {
            self.isLoading = false;
        }
    })
}));

const handleError = error => {
    if (error.response) {
        // The backend's error key is `error`, but not every response has one:
        // the API Gateway authorizer 403s with {message: "Forbidden"}, and
        // 502/504/HTML error pages have neither. new Error(undefined) yields
        // message === '', which ErrorDisplay renders as NOTHING — a totally
        // silent failure. Always fall back to something visible.
        const data = error.response.data || {};
        const message = data.error || data.message ||
            `Request failed (${error.response.status || 'network error'})`;
        const e = new Error(message);
        e.response = error.response;
        throw e;
    }
    throw error;
};

const processApiCall = flow(function* processApiCall(apiCall, self, applyTo) {
    self.isLoading = true;
    try {
        const response = yield apiCall();

        if (applyTo) {
            applySnapshot(applyTo, response.data);
        } else {
            return response.data;
        }
    } catch (error) {
        handleError(error);
    } finally {
        self.isLoading = false;
    }
});